<nav class="tab-row" [attr.aria-label]="ariaLabel ? (ariaLabel | translate) : null">
  <div class="tab-row-scroll" [attr.role]="isViewRow ? 'tablist' : null">
    @for (tab of tabs; track tab.id) { @if (tab.route) {
    <a
      class="tab"
      [class.tab--complimentary]="tab.activeColor === 'complimentary'"
      [routerLink]="tab.route"
      [queryParams]="tab.queryParams ?? null"
      routerLinkActive="tab--active"
      #rla="routerLinkActive"
      [routerLinkActiveOptions]="tab.exact ? exactMatch : subsetMatch"
      [attr.aria-current]="rla.isActive ? 'page' : null"
    >
      <ng-container [ngTemplateOutlet]="tabContent" [ngTemplateOutletContext]="{ $implicit: tab }"></ng-container>
    </a>
    } @else {
    <button
      type="button"
      role="tab"
      class="tab"
      [class.tab--active]="tab.id === active"
      [class.tab--complimentary]="tab.activeColor === 'complimentary'"
      [attr.aria-selected]="tab.id === active"
      (click)="select(tab)"
    >
      <ng-container [ngTemplateOutlet]="tabContent" [ngTemplateOutletContext]="{ $implicit: tab }"></ng-container>
    </button>
    } }
  </div>
</nav>

<ng-template #tabContent let-tab>
  {{ tab.label | translate }}
  @if (tab.trailingIcon) {
  <span class="material-icons-outlined tab-icon" aria-hidden="true">{{ tab.trailingIcon }}</span>
  } @if (tab.count) {
  <span class="tab-count e11-tabular-nums" [class.tab-count--alert]="tab.countStyle === 'alert'">{{ tab.count }}</span>
  }
</ng-template>
